/**
 * Loading Line
 * Animated linewhich is used to build content loader
 */
import React from 'react';

import { LineBackground, LineOverlay } from './LoadingLine.style';

const LoadingLine: React.FC<{
  backgroundColor?: string;
  colour?: string;
  opacity?: number;
  width?: string;
}> = ({ opacity = 1.0, width = '100%' }) => {
  return (
    <LineBackground width={width}>
      <LineOverlay opacity={opacity} />
    </LineBackground>
  );
};

export default LoadingLine;
